.messageFooter {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  white-space: nowrap;
}
.messageFooter.onlyMedia {
  bottom: 5px;
  inset-inline-start: 0;
  margin-inline-start: 10px;
  position: absolute;
  inset-inline-end: 5px;
  /** allow to click through the footer to the message body */
  pointer-events: none;
}
.messageFooter.onlyMedia * {
  /** enable clicks on reactions and other components inside the footer */
  pointer-events: initial;
}

.startWebxdcButton {
  font-size: 14px;
  margin: 10px 0;
  padding-bottom: 6px;
  padding-inline-start: 13px;
  padding-inline-end: 13px;
  padding-top: 7px;
}

.vcard {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  text-align: inherit;
  display: flex;
  background-color: rgba(0, 0, 0, 0.1333333333);
  border-radius: 10px;
  padding: 9px;
  padding-top: 0;
  padding-inline-end: 15px;
  min-width: 200px;
  max-width: 260px;
}
.vcard .avatar {
  margin-bottom: 0;
}
.vcard .contactInfo {
  display: flex;
  flex-direction: column;
  padding-inline-start: 10px;
  justify-content: center;
  min-width: 0;
}
.vcard .displayName {
  margin-bottom: 0;
  margin-top: 10px;
  font-weight: 200;
  font-size: medium;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}